export const SHIPPING_IDENTIFIER = {
  COMING_TO_TECHMICRO: "Coming to TechMicro USA",
  DIRECT_SHIP: "Direct Ship",
};

export const SHIPPING_IDENTIFIER_SHORT = {
  COMING_TO_TECHMICRO: "Coming to TMUSA",
  DIRECT_SHIP: "DS",
};

/**
 * Resolves the shipping identifier for a Purchase Order:
 * "Coming to TechMicro USA" or "Direct Ship"
 *
 * @param {Object} po - Purchase Order object
 * @returns {string} - "Coming to TechMicro USA" | "Direct Ship"
 */
export const getShippingIdentifier = (po) => {
  if (!po || typeof po !== "object") {
    return SHIPPING_IDENTIFIER.DIRECT_SHIP;
  }

  // 1. Explicit field takes precedence if present
  if (po.shippingIdentifier && typeof po.shippingIdentifier === "string") {
    const val = po.shippingIdentifier.trim();
    const lower = val.toLowerCase();
    if (lower.includes("coming") || lower.includes("tech") || lower.includes("tmusa")) {
      return SHIPPING_IDENTIFIER.COMING_TO_TECHMICRO;
    }
    if (lower.includes("direct") || lower === "ds") {
      return SHIPPING_IDENTIFIER.DIRECT_SHIP;
    }
    return val;
  }

  // 2. Direct POs (internal warehouse replenishment) default to TechMicro USA
  if (po.directPO === true) {
    return SHIPPING_IDENTIFIER.COMING_TO_TECHMICRO;
  }

  // 3. Status-based inference
  const status = String(po.status || "").toLowerCase();
  if (status.includes("coming") || status.includes("tmusa")) {
    return SHIPPING_IDENTIFIER.COMING_TO_TECHMICRO;
  }

  // 4. Shipping address / recipient company inference
  const shipping = po.shipping || {};
  const company = String(shipping.company || "").toLowerCase();
  const address1 = String(shipping.address_1 || "").toLowerCase();
  const email = String(shipping.email || "").toLowerCase();
  const city = String(shipping.city || "").toLowerCase();
  const state = String(shipping.state || "").toLowerCase();

  if (
    company.includes("techmicro") ||
    company.includes("tech micro") ||
    company.includes("tmusa") ||
    address1.includes("206 far hill") ||
    address1.includes("far hill") ||
    email.includes("purchasing@techmicrousa.com") ||
    (city.includes("bolingbrook") && state === "il")
  ) {
    return SHIPPING_IDENTIFIER.COMING_TO_TECHMICRO;
  }

  // 5. Default for customer drop-ship POs
  return SHIPPING_IDENTIFIER.DIRECT_SHIP;
};

export const isComingToTechMicro = (po) => {
  return getShippingIdentifier(po) === SHIPPING_IDENTIFIER.COMING_TO_TECHMICRO;
};

export const getShippingIdentifierShort = (po) => {
  return isComingToTechMicro(po)
    ? SHIPPING_IDENTIFIER_SHORT.COMING_TO_TECHMICRO
    : SHIPPING_IDENTIFIER_SHORT.DIRECT_SHIP;
};
